import IUserRepository from '../../2_domain/user/iUserRepository';
import User, {
  PasswordInfo,
  ResetInfo,
  userFromDto,
} from '../../2_domain/user/user';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import Connection2 from '../core/connection2';
import { GET_SHORT_TERM_TOKEN } from './userQuery';

class UserRepository implements IUserRepository {
  //LINK - id 8
  signIn = async (signInInfo: {
    email: Email;
    password: Password;
  }): Promise<AccessToken> => {
    const res = await Connection2.requestPost('clinicLogin', {
      identifier: signInInfo.email,
      password: signInInfo.password,
    });
    return res.accessToken;
  };

  //LINK - id 2
  isLogined = async (): Promise<boolean> => {
    const res = await Connection2.requestGet('clinic/CheckState');
    return res.code === 200;
  };

  //LINK - id 20
  getCurrent = async (): Promise<User> => {
    const { code, ...res } = await Connection2.requestGet(
      'clinic/queryClinicMyInfo'
    );
    return userFromDto(res);
  };

  // LINK - id 11
  requestReset = async (email: Email): Promise<void> => {
    await Connection2.requestPost('clinicRequestReset', {
      identifier: email,
    });
    return;
  };

  // LINK - id 4
  detectMatch = async (resetInfo: ResetInfo): Promise<boolean> => {
    const res = await Connection2.requestPost('clinicComparePassword', {
      code: resetInfo.code,
      password: resetInfo.password,
    });

    return res?.isNewPasswordDifferentFromPreviousOne === true;
  };

  // LINK - id 12
  resetPassword = async (resetInfo: ResetInfo): Promise<void> => {
    await Connection2.requestPost('clinicResetPassword', {
      code: resetInfo.code,
      password: resetInfo.password,
    });
    return;
  };

  //LINK - id 13
  //NOTE - password not camel case, response coe is string 200,
  changePassword = async (passwordInfo: PasswordInfo): Promise<void> => {
    await Connection2.requestPost('clinic/ChangePassword', {
      currentpassword: passwordInfo.currentPassword,
      newpassword: passwordInfo.newPassword,
    });
    return;
  };

  //LINK - id 1
  getShortTermToken = async (): Promise<AccessToken> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_SHORT_TERM_TOKEN,
      fetchPolicy: 'no-cache',
    });
    return res.data['queryShortTermToken']['accessToken'];
  };
}

export default UserRepository;
